import React, { useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { IoIosArrowUp } from 'react-icons/io';

const Accordion = () => {
  const [select, setSelect] = useState(null);

  const trogle = (i) => {
    if (select === i) {
      setSelect(null);
    } else {
      setSelect(i);
    }
  };

  const dataOdd = [
    {
      id: 1,
      que: '¿Cómo se calcula el ISR?',
      ans: 'Book online by clicking on the Book Now button',
    },
    {
      id: 2,
      que: '¿Cual es la multa por no declarar?',
      ans: 'Yes! We offer foods for both vegetarians and non-vegetarian visitors in snacks as well as the main course. There are many veg dishes like Cabbage Salad, samosa, rice, soft drinks, noodles, veg curry, etc. For non-vegans, we offer chicken and lamb kebab, a BBQ buffet dinner, along with special Shisha.',
    },
    {
      id: 3,
      que: '¿Que pasa si no apruebo a tiempo mi declaración?',
      ans: 'Only bring the things you need, such as your phone, camera, sunglasses, etc. A handbag may be used to carry your belongings.',
    },
    {
      id: 4,
      que: '¿Que productos o servicios puedo deducir de mis impuestos?',
      ans: 'There are different timings of the safari in the desert of Dubai depending on if you want morning desert safari, evening safari, or overnight desert safari. Evening safari starts after noon before sun sets. In contrast, morning and overnight safaris begin with their respective times of morning and evening.',
    },
    {
      id: 5,
      que: '¿Qué es el IVA?',
      ans: 'Timing and ticket prices depend on the package you select.',
    },
    {
      id: 6,
      que: '¿Cómo se qué regimen tengo?',
      ans: 'Here is the list of other popular Dubai activities that you can go to while on your trip to UAE:Visiting Burj Khalifa Dhow Cruise Dubai MarinThe Dubai FountainHeritage Village The Dubai Mallmany more...',
    },
    {
      id: 7,
      que: '¿Como cancelo una factura?',
      ans: 'You must be happy to know that there is no age limit for desert safari Dubai; you can bring an infant. However, if an infant is too small (less than 2 years), you probably would not go with him on dune drive. Or you may skip the dune ride and try out other fun activities.',
    },
    {
      id: 8,
      que: '¿Puedo declararme en ceros aunque mi cálculo de otra cantidad?',
      ans: 'You must be happy to know that there is no age limit for desert safari Dubai; you can bring an infant. However, if an infant is too small (less than 2 years), you probably would not go with him on dune drive. Or you may skip the dune ride and try out other fun activities.',
    },
    {
      id: 9,
      que: '¿Cómo facturo en la app?',
      ans: 'You must be happy to know that there is no age limit for desert safari Dubai; you can bring an infant. However, if an infant is too small (less than 2 years), you probably would not go with him on dune drive. Or you may skip the dune ride and try out other fun activities.',
    },
    {
      id: 10,
      que: '¿Como cancelo una factura?',
      ans: 'You must be happy to know that there is no age limit for desert safari Dubai; you can bring an infant. However, if an infant is too small (less than 2 years), you probably would not go with him on dune drive. Or you may skip the dune ride and try out other fun activities.',
    },
    {
      id: 11,
      que: '¿Puedo declararme en ceros aunque mi cálculo de otra cantidad?',
      ans: 'You must be happy to know that there is no age limit for desert safari Dubai; you can bring an infant. However, if an infant is too small (less than 2 years), you probably would not go with him on dune drive. Or you may skip the dune ride and try out other fun activities.',
    },
  ];

  return (
    <section id="Questions">
      <div>
        <div className="md:pt-[100px] pt-[20px]">
          <div className="">
            <div>
              {dataOdd?.map((item) => {
                return (
                  <div key={item.id} className="mb-[10px]">
                    <div
                      className="flex items-center"
                      onClick={() => trogle(item.id)}
                    >
                      <h2 className="md:text-[24px] text-[16px]  font-[400] cursor-pointer m-0 mt-0 py-5">
                        {item.que}
                      </h2>
                    
                       <button className='text-[24px]'>
                       {select === item.id ? (
                          <IoIosArrowUp />
                        ) : (
                          <IoIosArrowDown />
                        )}
                       </button>
                   
                    </div>
                    <div className="">
                      <p
                        className={`md:text-[20px] text-[14px] font-normal text-[#123a3280] pb-1 mb-[20px] duration-300 ${
                          select === item.id ? '' : 'hidden'
                        } `}
                      >
                        {item.ans}
                      </p>
                    </div>
                    <div className="border-brand-light-gray border border-b-2 "></div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accordion;